import { useState } from 'react';
import { Collapse, Button, Card, CardContent, Box } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess'; // Upward arrow
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Downward arrow
import PropTypes from 'prop-types';

const CollapsibleBox = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <Button
        onClick={() => setOpen(!open)}
        sx={{
          display: 'flex',
          alignItems: 'center',
          padding: '8px',
          width: '100%',
          textAlign: 'left',
        }}
      >
        <div>
          <Box
            component="span"
            sx={{
              color: '#3C75C7',
              fontWeight: 600,
              fontSize: '14px',
              lineHeight: '16px',
              letterSpacing: '1.4px',
              textTransform: 'uppercase',
              padding: '8px',
              display: 'flex',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {title}
          </Box>
        </div>
        {open ? (
          <ExpandLessIcon sx={{ marginLeft: 'auto' }} />
        ) : (
          <ExpandMoreIcon sx={{ marginLeft: 'auto' }} />
        )}
      </Button>
      <Collapse in={open}>
        <Card
          sx={{
            padding: '3px',
            marginTop: '4px',
            boxShadow: 'none',
          }}
        >
          <CardContent>{children}</CardContent>
        </Card>
      </Collapse>
    </div>
  );
};
CollapsibleBox.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default CollapsibleBox;
